<template>
  <div>
    <span class="btn btn-default btn-file"
          :disabled="showSummary">
        Escolher...
        <input type="file" :name="images" v-on:change="imagesAdd" multiple accept="image/*" 
        class="form-control" 
        :id="formField.objectId" 
        :disabled="showSummary" />

    <p class="text-muted field-desc">São aceitos apenas imagens. Ex: jpg, jpeg, png, bmp, gif</p>
    <span class="help-block" v-show="formField.invalid">O campo deve ser preenchido corretamente</span>
    </span>
    <div v-for="imgDatum in imageData" class="file-upload-form">
      <img class="preview" :src="imgDatum">
    </div>
  </div>
</template>

<script>
import {
  createDocumentFile
} from '../Global'

export default {
  props: ['formField', 'showSummary'],
  data () {
    this.updatedByComponent = true
    // ALWAYS WHEN A VARIABLE OF DATA SET IS CHANGED,
    // YOU MUST SET UPDATEDBYCOMPONENT TO TRUE
    return {
      images: [],
      imageData: []
    }
  },
  updated () {
    if (!this.updatedByComponent) {
      this.imageData = []
      this.updatedByComponent = true
    } else {
      this.updatedByComponent = false
    }
  },
  methods: {
    imagesAdd (event) {
      this.images = event.target.files || event.dataTransfer.files
      this.imageData = []
      this.updatedByComponent = true
      this.createImages(event)
    },
    createImages (event) {
      for (var i = 0; i < this.images.length; i++) {
        var reader = new FileReader()
        var vm = this
        reader.onload = (e) => {
          vm.imageData.push(e.target.result)
          this.updatedByComponent = true
        }
        reader.readAsDataURL(this.images[i])
      }
      createDocumentFile(this.formField, event)
    },
    removeImage (key) {
      // this.images.splice(key, 1)
      this.imageData.splice(key, 1)
    }
  }
}
</script>

<style>
  .btn-file {
    position: relative;
    overflow: hidden;
  }
  .btn-file[disabled] {
    background-color: #eee!important;
    opacity: 1!important;
  }
  .btn-file input[type=file]:disabled {
    cursor: not-allowed;
  }
  .file-upload-form, .image-preview {
      font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
      padding: 20px;
  }
  img.preview {
      width: 200px;
      background-color: white;
      border: 1px solid #DDD;
      padding: 5px;
  }
</style>



// WEBPACK FOOTER //
// DocumentInputPreview.vue?f967acee